module.exports = __webpack_public_path__ + "img/i_es_family.296674d6.svg";